/*
* Sets Products active on product page
* Sets Cart active on carts page
*/

window.addEventListener('DOMContentLoaded', () => {
  const activeMapping = [
    ['/cart', '/cart'],
    ['/products', '/collections/all'],
    ['/collections', '/collections/all']
  ]

  activeMapping.forEach(i => {
    if (window.location.pathname.includes(i[0])) {
      const els = document.querySelectorAll(`header a[href*="${i[1]}"]`)
      els.forEach(el => el.classList.add('header__active-menu-item'))
    }
  })
})